import { dispatchErrorWrap, dispatchSuccessWrap } from './genericActions'

import { actionTypes } from '../types'
import { constants } from '../../App.constants';
import moment from 'moment-timezone'

const axios = require('axios');

export const canRegister = (email, callback) => {
    return async (dispatch) => {
        try {
            let header = {
                headers: {
                    'Content-Type': 'application/json'
                }
            }

            let reqPayload = {
                email: email
            }

            const payload = await axios.post(constants.apiUrl + "/auth/canRegisterWithDetails", reqPayload, header);
            if (payload.data) {

                dispatchSuccessWrap(actionTypes.CAN_REGISTER, { reset: payload.data }, dispatch);
                callback(null, payload.data.canRegister);

            }

        } catch (error) {
            callback('Unable to verify email');
            dispatchErrorWrap('Unable to verify email', dispatch);
            //dispatchErrorWrap(actionTypes.SIGN_IN, { isLoginTokenValid: false, currentUser: null, stripeConnected: false }, dispatch);
        }
    }
}
export const autoLoginUser = (token) => {
    return async (dispatch) => {
        let header = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': token
            }
        }
        try {
            const payload = await axios.get(constants.apiUrl + "/account/", header);
            let stripeConnected;
            if (payload.data && payload.data.userId) {

                localStorage.setItem('loginToken', token);
                localStorage.setItem('email', payload.data.email);
                localStorage.setItem('userId', payload.data.userId);
                localStorage.setItem('userName', payload.data.name);
                localStorage.setItem('user', JSON.stringify(payload.data));

                let headerForStripeCheck = {
                    headers: {
                        'Content-Type': 'application/json',
                        'login-token': token
                    }
                }

                try {
                    const payloadForStripeVerification = await axios.get(constants.ticketsBaseUrl + "/connectedUser", headerForStripeCheck);
                    payloadForStripeVerification.data.connected
                        ? stripeConnected = true
                        : stripeConnected = false
                } catch (err) { }

                dispatchSuccessWrap(actionTypes.SIGN_IN, { isLoginTokenValid: true, currentUser: payload.data, stripeConnected: stripeConnected }, dispatch);

            }


        } catch {
            dispatchErrorWrap(actionTypes.SIGN_IN, { isLoginTokenValid: false, currentUser: null, stripeConnected: false }, dispatch);

        }

    }
}
export const signIn = (values, callback) => {
    return async (dispatch) => {
        try {
            let header = {
                headers: {
                    'Content-Type': 'application/json',
                    'login-token': localStorage.getItem('loginToken')
                }
            }

            let reqPayload = values;

            const payload = await axios.post(constants.apiUrl + "/auth/login", reqPayload, header);
            if (payload.data) {

                localStorage.setItem('loginToken', payload.data.loginToken);
                localStorage.setItem('email', payload.data.email);
                localStorage.setItem('userId', payload.data.userId);
                localStorage.setItem('userName', payload.data.name);
                localStorage.setItem('user', JSON.stringify(payload.data));
                dispatchSuccessWrap(actionTypes.SIGN_IN, { isLoginTokenValid: true, currentUser: payload.data }, dispatch);
                callback(null, payload.data);

            }

        } catch (error) {
            callback('Invalid Credentials');
            dispatchErrorWrap('Invalid Credentials', dispatch);
            //dispatchErrorWrap(actionTypes.SIGN_IN, { isLoginTokenValid: false, currentUser: null, stripeConnected: false }, dispatch);
        }

    }


}

export const resetPassword = (values, callback) => {
    return async (dispatch) => {
        try {
            let header = {
                headers: {
                    'Content-Type': 'application/json',
                    'login-token': localStorage.getItem('loginToken')
                }
            }

            let reqPayload = values

            const payload = await axios.post(constants.apiUrl + "/account/resetPassword", reqPayload, header);
            if (payload.data) {

                dispatchSuccessWrap(actionTypes.RESET_PASSWORD, { reset: payload.data }, dispatch);

            }

            callback(null);


        } catch (error) {
            callback('Unable to send reset password email');
            dispatchErrorWrap('Unable to send reset password email', dispatch);
            //dispatchErrorWrap(actionTypes.SIGN_IN, { isLoginTokenValid: false, currentUser: null, stripeConnected: false }, dispatch);
        }

    }


}

export const signUp = (values, callback) => {
    return async (dispatch) => {
        try {
            let header = {
                headers: {
                    'Content-Type': 'application/json'
                }
            }

            let reqPayload = {
                "email": values.email,
                "password": values.password,
                "timezone": moment.tz.guess(),
                "name": values.name,
                "hasAcceptedLatestTerms": true
            }

            const payload = await axios.post(constants.apiUrl + "/auth/register", reqPayload, header);
            if (payload.data) {

                localStorage.setItem('loginToken', payload.data.loginToken);
                localStorage.setItem('email', payload.data.email);
                localStorage.setItem('userId', payload.data.userId);
                localStorage.setItem('userName', payload.data.name);
                localStorage.setItem('user', JSON.stringify(payload.data));
                dispatchSuccessWrap(actionTypes.SIGN_UP, { isLoginTokenValid: true, currentUser: payload.data }, dispatch);
                callback(null, payload.data);

            }

        } catch (error) {
            callback('Invalid Credentials');
            dispatchErrorWrap('Invalid Credentials', dispatch);
            //dispatchErrorWrap(actionTypes.SIGN_IN, { isLoginTokenValid: false, currentUser: null, stripeConnected: false }, dispatch);
        }

    }


}

export const autoSignOut = () => {
    return async (dispatch) => {
        localStorage.removeItem('loginToken');
        localStorage.removeItem('email');
        localStorage.removeItem('userId');
        localStorage.removeItem('userName');
        localStorage.removeItem('user');
        // dispatchSuccessWrap(actionTypes.RESET_POSTINGS_STATE, {}, dispatch)
        dispatchSuccessWrap(actionTypes.SIGN_OUT, { isLoginTokenValid: false, currentUser: undefined }, dispatch)
    }

}

export const signOut = (cb) => {
    return async (dispatch, getState) => {
        try {
            const headers = {
                headers: {
                    'Content-Type': 'application/json',
                    'login-token': localStorage.getItem('loginToken')
                }
            }
            let reqPayload = JSON.parse(localStorage.getItem('user'));

            await axios.post(constants.apiUrl + "/auth/logout", reqPayload, headers);
            localStorage.removeItem('loginToken');
            localStorage.removeItem('email');
            localStorage.removeItem('userId');
            localStorage.removeItem('userName');
            localStorage.removeItem('user');
            //dispatchSuccessWrap(actionTypes.RESET_POSTINGS_STATE, {}, dispatch)
            dispatchSuccessWrap(actionTypes.SIGN_OUT, { isLoginTokenValid: false, currentUser: undefined }, dispatch)
            cb()
        } catch (error) {
            dispatchErrorWrap(error, dispatch);
        }

    }


}

export const checkIfLoggedIn = (cb) => {
    return async (dispatch, getState) => {

        let isLoginTokenValid = false;
        let currentUser;

        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'login-token': localStorage.getItem('loginToken')
            }
        }

        try {

            const payload = await axios.get(constants.apiUrl + "/account", headers);
            //console.log('payload cal Info', payload);
            if (payload.data && payload.data.userId) {
                isLoginTokenValid = true;
                currentUser = payload.data;
                cb(payload.data)
            } else {
                isLoginTokenValid = false;
                cb(null)
            }

        } catch (error) {
            isLoginTokenValid = false;
            cb(null)
        }
        console.log(isLoginTokenValid);
        dispatchSuccessWrap(actionTypes.CHECK_AUTHENTICATION_TOKEN, {
            isLoginTokenValid: isLoginTokenValid,
            currentUser: currentUser
        }, dispatch)

    }
}


